module.exports = __webpack_public_path__ + "img/Pentagram-Active.80dac620.svg";